import { Component, OnInit } from '@angular/core';
import { Searchgeneral } from 'src/app/model/searchgeneral.model';
import { Question } from 'src/app/model/question.model';
import { UserService } from 'src/app/services/user/user.service';
import { NgForm } from '@angular/forms';
import { RoleService } from 'src/app/services/role/role.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormControl, FormArray, Validators, FormBuilder } from '@angular/forms';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import 'ag-grid-community';
import { DatePipe } from '@angular/common';
import { ButtonRendererComponent } from 'src/app/button-renderer.component';

@Component({
  selector: 'app-answers',
  templateUrl: './answers.component.html',
  styleUrls: ['./answers.component.css'],
  providers: [DatePipe]
})
export class AnswersComponent implements OnInit {

  correctAns: string;
  questionDataAny: any;
  searchGeneral: Searchgeneral;
  question: Question;
  projectDetails: any;
  data: any;
  showDataBoolTable: boolean = false;
  selectedOption = [];
  surveyForm: FormGroup;
  showDataBool: boolean = false;
  isListLoading: boolean = false;
  vendorSelectBool: boolean = false;
  addQuestionBool: boolean = false;
  rowData: any;
  ansGridBool: boolean = false;
  rowDataForAns: any;
  pagination = true;
  paginationPageSize = 5;
  private gridApi;
  private gridColumnApi;
  rightAns: any;
  ansString: string;
  vendName: string;
  singleMultipleBool: boolean = false;
  allRowDataForAns: any;
  columnDefs = [
    //{headerName: '', field: '', width: 50, headerCheckboxSelection: true, checkboxSelection: true, minWidth:40},
    { headerName: "#", field: "index", maxWidth: 40, valueGetter: "node.rowIndex + 1" },
    { headerName: "Survey ID", field: "surveyId", maxWidth: 100, filter: true, sortable: true, resizable: true },
    { headerName: "Question", field: "question", resizable: true },
    //{ headerName: "Options", field: "options",resizable: true},
    { headerName: "Answer Submitted", field: "submitAnswer", resizable: true },
    { headerName: "Correct Answer", field: "correctAnswer", resizable: true },
    { headerName: "Correct", field: "isCorrect", resizable: true },

  ];
  autoGroupColumnDef = {
    headerName: 'Select',
    field: 'select',
    minWidth: 250,
    cellRenderer: 'agGroupCellRenderer',
    cellRendererParams: { checkbox: true },
  };
  defaultColDef = {
    flex: 1,
    minWidth: 100,
  };
  rowSelection = 'single';
  frameworkComponents: any;
  constructor(private userService: UserService, private datePipe: DatePipe, private roleservice: RoleService, private toastr: ToastrService) {
    this.frameworkComponents = {
      buttonRenderer: ButtonRendererComponent,
    }
  }

  ngOnInit() {
    this.searchGeneral = new Searchgeneral();
    this.question = new Question();
    this.ansGridBool = false;
    this.showDataBoolTable = false;
  }

  SubmitSearchListForm(form: NgForm) {
    debugger;
    this.isListLoading = true;
    this.vendorSelectBool = false;
    this.getVendorList(this.searchGeneral.projectid);
    this.addQuestionBool = false;
    this.roleservice.SearchProjectDetails(this.searchGeneral).subscribe(
      (data: any) => {
        this.isListLoading = false;
        this.projectDetails = data;
        if (this.projectDetails.length === 0) {
          this.showDataBool = false;
          this.toastr.error("No items found", '', { progressBar: true });
        }
        else {
          this.showDataBool = true;
          this.showDataBoolTable = false;
        }
      }
    )
  }

  getVendorList(projectId) {
    debugger;
    this.userService.getProjectSpecificCountryList(projectId).subscribe(
      (data) => {
        if (data) {
          this.data = data;
        }
      }
    )
  }

  countrySelected(event: any) {
    this.searchGeneral.vendorId = event.target.value;
    this.roleservice.SearchSubmittedAnswers(this.searchGeneral).subscribe(
      (data: any) => {
        if (data) {
          this.showDataBoolTable = true;
          this.rowData = data;
        }
      })
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  onGridReadyForAns(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }



  getAllRows() {
    this.allRowDataForAns = [];
    this.gridApi.forEachNode(node => this.allRowDataForAns.push(node.data));
    return this.allRowDataForAns;
  }




}
